import { MIN_SEARCH_LENGTH } from '@/utils/constants.js';

import { useSearchStore, useXundStore } from '@/store.js';

export const useSearchRestingState = () => {
    const search = useSearchStore((state) => state.search);
    const selectedProfessional = useSearchStore((state) => state.selectedProfessional);
    const selectedSpecialty = useSearchStore((state) => state.selectedSpecialty);
    const selectedChainConfig = useSearchStore((state) => state.selectedChainConfig);
    const showAvailableProfessionals = useSearchStore((state) => state.showAvailableProfessionals);
    const selectedTreatments = useSearchStore((state) => state.selectedTreatments);
    const isXundTriage = useXundStore((state) => state.isXundTriage);

    return (
        (search ?? '').trim().length < MIN_SEARCH_LENGTH &&
        !selectedProfessional &&
        !selectedSpecialty &&
        !selectedChainConfig &&
        !showAvailableProfessionals &&
        !isXundTriage &&
        Object.keys(selectedTreatments ?? {}).length === 0
    );
};
